const config = {

    includeUrl: 'include.icly.ch',
    restUrl: 'rest.innocardloyalty.ch',
    restPort: '443'
};

export default config;